// Libs
import React from 'react';
import styled from 'styled-components';

const Svg = styled.svg`
	cursor: pointer;
	transition: transform 0.15s ease, filter 0.15s ease;
	&:hover {
		transform: scale(1.15);
		filter: drop-shadow(0 0 1px rgba(255, 255, 255, 0.7));
	}
`;

export default ({ fill = 'white', fillOpacity = '0.80' }) => (
	<Svg
		width='24'
		height='24'
		viewBox='0 0 24 24'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
		style={{ color: fill }}
	>
		<path
			fillRule='evenodd'
			clipRule='evenodd'
			d='M11 5V11H5V13H11V19H13V13H19V11H13V5H11Z'
			fill={fill}
			fillOpacity={fillOpacity}
		/>
	</Svg>
);
